import { render, staticRenderFns } from "./select.vue?vue&type=template&id=0f69ae33&"
import script from "../descriptors/select.js?vue&type=script&lang=js&"
export * from "../descriptors/select.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports